import type { BulkData, CoilData, DimensionData, LogData, Product } from 'shared/products/domain/product';
import type { ProductType } from 'shared/products/domain/productType';

export interface ProductFormValues {
  name: string;
  code: string | undefined;
  quality: string | undefined;
  color: string | undefined;
  description: string;
  type: ProductType;
  productGroupId: string | null;
  logData: LogData | null;
  coilData: CoilData | null;
  bulkData: BulkData | null;
  dimensionData: DimensionData | null;
}

// Maps a source product to the dialog's form values; copyName lets the copy path suffix the name.
export function buildProductFormValues(
  source: Product,
  copyName: (name: string) => string,
): ProductFormValues {
  return {
    name: copyName(source.name),
    code: source.externalCode ?? undefined,
    quality: source.quality ?? undefined,
    color: source.color ?? undefined,
    description: source.description,
    type: source.type,
    productGroupId: source.productGroupId,
    logData: source.logData,
    coilData: source.coilData,
    bulkData: source.bulkData,
    dimensionData: source.dimensionData,
  };
}
